export default __webpack_public_path__ + "static/media/india.abb386b1.svg";